module.exports = "<div class=internal-order-grace-period> <span class=q-boldest>Scheduled Release:</span> <span> {%- orderScheduledReleaseTimePeriod %}</span> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/orderReleaseType.html
// module id = 1365
// module chunks = 1